import React from 'react';
import HeroSection from '../components/about/HeroSection';
import CompanyStory from '../components/about/CompanyStory';
import Achievements from '../components/about/Achievements';
import MissionVision from '../components/about/MissionVision';
import WhyChoose from '../components/about/WhyChoose';
import CoreValues from '../components/about/CoreValues';
import IndustriesServed from '../components/about/IndustriesServed';
import CallToAction from '../components/about/CallToAction';

const About = () => {
  return (
    <div>
      <HeroSection />
      <CompanyStory />
      <Achievements />
      <MissionVision />
      <WhyChoose />
      <CoreValues />
      <IndustriesServed />
      <CallToAction />
    </div>
  );
};

export default About;